<div aria-hidden="true"
  class="tw-overflow-y-auto tw-overflow-x-hidden tw-fixed tw-z-50 tw-w-full tw-min-w-max tw-flex tw-justify-center tw-items-center tw-inset-0 tw-h-screen tw-max-h-full tw-backdrop-brightness-50"
  data-modal-backdrop="static" tabindex="-1">
  <div class="tw-flex tw-justify-center tw-items-center tw-h-screen tw-w-1/3">
    <div class="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-lg tw-w-full">
      <div class="tw-text-center">
        <h2 class="tw-text-xl tw-font-bold tw-text-green-900">
          {{ notificationTitle }}
        </h2>
        <p class="tw-mt-2 tw-text-green-800">
          {{ notificationBody }}
        </p>
      </div>

      <div class="tw-flex tw-justify-center tw-mt-6">
        <button
          class="btn btn-outline-danger tw-h-12 tw-w-40"
          (click)="acknowledge()"
        >
          Acknowledge
        </button>
      </div>
    </div>
  </div>
</div>
